import { z } from 'zod';
import { respuestaPaginadaSchema } from './costo.schema.js';
/**
 * Schema Zod para validar respuestas de endpoints de Análisis de Maquinaria.
 */
export const RegistroUsoMaquinariaSchema = z.object({
    entryNo: z.number().int(),
    fecha: z.string(),
    origen: z.enum(['PRODUCTION', 'SANDBOX']),
    codigoMaquina: z.string(),
    nombreMaquina: z.string().nullable(),
    tipoMaquina: z.string().nullable(),
    worksNo: z.string(),
    proyectoDisplay: z.string().nullable(),
    taskNo: z.string().nullable(),
    tareaDisplay: z.string().nullable(),
    origenUso: z.enum(['PARTE_TRABAJO', 'ASSEMBLY']),
    documentNo: z.string().nullable(),
    horasUso: z.number().nullable(),
    tarifaAplicadaLcy: z.number(),
    montoIngresoMaquinaLcy: z.number(),
    montoCostoObraLcy: z.number(),
});
export const ResumenUtilizacionMaquinaSchema = z.object({
    codigoMaquina: z.string(),
    nombreMaquina: z.string().nullable(),
    tipoMaquina: z.string().nullable(),
    worksNo: z.string(),
    proyectoDisplay: z.string().nullable(),
    taskNo: z.string().nullable(),
    tareaDisplay: z.string().nullable(),
    origenUso: z.enum(['PARTE_TRABAJO', 'ASSEMBLY']),
    anio: z.number().int(),
    mes: z.number().int().min(1).max(12),
    totalHoras: z.number(),
    totalIngresoLcy: z.number(),
});
export const ResumenGeneralMaquinaSchema = z.object({
    codigoMaquina: z.string(),
    nombreMaquina: z.string().nullable(),
    tipoMaquina: z.string().nullable(),
    totalHoras: z.number(),
    totalIngresoPartesLcy: z.number(),
    totalIngresoRecursosLcy: z.number(),
    totalIngresoLcy: z.number(),
    totalGastoLcy: z.number(),
});
export const RegistroGastoMaquinaSchema = z.object({
    entryNo: z.number().int(),
    fecha: z.string(),
    documentNo: z.string().nullable(),
    description: z.string().nullable(),
    itemCategoryCode: z.string().nullable(),
    tipoMovimiento: z.string().nullable(),
    vendorName: z.string().nullable(),
    totalCostLcy: z.number(),
});
export const PuntoMensualMaquinariaSchema = z.object({
    anio: z.number().int(),
    mes: z.number().int().min(1).max(12),
    totalIngresoLcy: z.number(),
    totalGastoLcy: z.number(),
});
export const CategoriaGastoMaquinariaSchema = z.object({
    categoria: z.string(),
    totalGastoLcy: z.number(),
});
export const AnalisisGeneralMaquinariaSchema = z.object({
    porMaquina: z.array(ResumenGeneralMaquinaSchema),
    porMes: z.array(PuntoMensualMaquinariaSchema),
    porCategoriaGasto: z.array(CategoriaGastoMaquinariaSchema),
});
export const RespuestaUsoMaquinariaSchema = respuestaPaginadaSchema(RegistroUsoMaquinariaSchema);
export const RespuestaUtilizacionMaquinariaSchema = z.array(ResumenUtilizacionMaquinaSchema);
export const RespuestaAnalisisGeneralMaquinariaSchema = AnalisisGeneralMaquinariaSchema;
export const RespuestaGastoMaquinaSchema = z.array(RegistroGastoMaquinaSchema);
export const UnidadProduccionSchema = z.object({
    skUnidadProduccion: z.number().int(),
    nombre: z.string(),
    descripcion: z.string().nullable(),
});
export const MaquinaUnidadProduccionSchema = z.object({
    codigoMaquina: z.string(),
    nombreMaquina: z.string().nullable(),
    skUnidadProduccion: z.number().int().nullable(),
    totalHoras: z.number(),
    totalIngresoPartesLcy: z.number(),
    totalIngresoRecursosLcy: z.number(),
    totalIngresoLcy: z.number(),
    totalGastoLcy: z.number(),
});
export const AnalisisUnidadesProduccionSchema = z.object({
    unidades: z.array(UnidadProduccionSchema),
    maquinas: z.array(MaquinaUnidadProduccionSchema),
});
/** Body de POST/PUT de una unidad. */
export const GuardarUnidadProduccionSchema = z.object({
    nombre: z.string().trim().min(1, 'El nombre es obligatorio').max(100),
    descripcion: z.string().trim().max(400).nullable().optional(),
});
/** Body de la asignación masiva máquina → unidad (null = quitar de su unidad). */
export const AsignarMaquinasUnidadSchema = z.object({
    codigosMaquina: z.array(z.string().min(1).max(50)).min(1).max(500),
    skUnidadProduccion: z.number().int().nullable(),
});
//# sourceMappingURL=maquinaria.schema.js.map